/** Axios fills `error.message` with this when the body has no usable copy. */
const AXIOS_STATUS_CODE_MESSAGE = /^Request failed with status code \d+$/

/** Extract a human-readable message from an Axios/API error body. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const data = (error as { response?: { data?: { message?: unknown; errors?: unknown } } })?.response?.data
  const fromMessage = typeof data?.message === 'string' ? data.message.trim() : ''
  if (fromMessage) {
    return fromMessage
  }

  const errors = data?.errors
  if (errors && typeof errors === 'object') {
    const firstKey = Object.keys(errors as Record<string, unknown>)[0]
    const val = firstKey ? (errors as Record<string, unknown>)[firstKey] : undefined
    if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'string') {
      return val[0]
    }
  }

  const message = (error as { message?: unknown })?.message
  if (typeof message === 'string' && message.trim()) {
    const trimmed = message.trim()
    if (!AXIOS_STATUS_CODE_MESSAGE.test(trimmed)) {
      return trimmed
    }
  }

  return fallback
}
